var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVitals = function SvgIconVitals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.815 15v7h12v-6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.815,
    cy: 13,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.815 1h2.8c.6 0 1.1.5 1 1.1l-1.6 11.1c-.1 1-1 1.7-2 1.7h-6.5c-1 0-1.8-.7-2-1.7L.015 2.1c-.1-.6.3-1.1 1-1.1h2.8m0-1v2m6-2v2"
  })))));
};
export { SvgIconVitals as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8cGF0aCBkPSJNNi44MTUgMTV2N2gxMnYtNiIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxOC44MTUiIGN5PSIxMyIgcj0iMyIvPgogICAgICAgICAgICA8cGF0aCBkPSJNOS44MTUgMWgyLjhjLjYgMCAxLjEuNSAxIDEuMWwtMS42IDExLjFjLS4xIDEtMSAxLjctMiAxLjdoLTYuNWMtMSAwLTEuOC0uNy0yLTEuN0wuMDE1IDIuMWMtLjEtLjYuMy0xLjEgMS0xLjFoMi44TTMuODE1IDB2Mk05LjgxNSAwdjIiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";